import { render, staticRenderFns } from "./InputGroups.vue?vue&type=template&id=1ee8a710&"
import script from "./InputGroups.vue?vue&type=script&lang=js&"
export * from "./InputGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports